import { validationFailed, createFailure, validationSuccessful, ValidationResult } from "sprint-common-web";

import { ContentVersion } from "../../../../../../common/types/ContentReference";
import { FileRecordMovieVersionItem } from "../../../../common/types/FileRecordMovieItem";
import { FileRecordEpisodeVersionItem } from "../../../../common/types/FileRecordTvSeriesItem";

export interface ValidateEditContentVersionsRequest {
    selectedVersionIds: string[];
    versions: ContentVersion[];
    isVersionRequired: boolean;
    isOrphanedChangeAllowed: boolean;
}

export const validateEditContentVersions = ({
    selectedVersionIds,
    isVersionRequired,
    isOrphanedChangeAllowed,
    versions
}: ValidateEditContentVersionsRequest): ValidationResult => {
    if (isVersionRequired && !selectedVersionIds.length) {
        return requiredVersionValidationFailure();
    }

    const isChangeForOrphaned = getIsChangeForOrphaned(versions, selectedVersionIds);

    if (isChangeForOrphaned) {
        return resolveOrphanedChangeValidationResult(isOrphanedChangeAllowed);
    }

    return validationSuccessful();
};

const getIsChangeForOrphaned = (
    versions: FileRecordEpisodeVersionItem[] | FileRecordMovieVersionItem[],
    selectedVersionIds: string[]
): boolean => {
    const orphanedVersionIds = versions.filter((v) => !v.buzzVersion).map((version) => version.id);

    if (selectedVersionIds.some((id) => orphanedVersionIds.includes(id))) {
        return true;
    }

    return false;
};

const resolveOrphanedChangeValidationResult = (isOrphanedChangeAllowed: boolean) => {
    return isOrphanedChangeAllowed ? validationSuccessful() : orphanedChangeValidationFailure();
};

const requiredVersionValidationFailure = () => {
    return validationFailed([
        createFailure(resolveVersionValidationMessage(requiredVersionSuffix), "required-version")
    ]);
};

const orphanedChangeValidationFailure = () => {
    return validationFailed([createFailure(resolveVersionValidationMessage(orphanedChangeSuffix), "orphaned-change")]);
};

const resolveVersionValidationMessage = (suffix: string): string => {
    return "Buzz notification was already sent with current content version. " + suffix;
};

const requiredVersionSuffix = "Cannot send buzz notification without content version. Please select new version.";

const orphanedChangeSuffix = "Cannot change to orphaned version.";
